/**
 * @file   Source/gitcha_Web/src/mobile/components/GitchaContentHeaderMob.js
 * @brief  This file is responsible for handling tab contents in General and Match view
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";

import {
  combineKey,
  decodeParam,
  getLocalStorage,
  removeLocalStorage,
  renameKey,
  setLocalStorage,
} from "../../helpers/common";
import { fetchUserDetails } from "../../actions/userprofile";
import { getMatchClientList } from "../../services/agentClientsService";
import {
  BUY,
  DEFAULT_MAX_BUDGET_BUY,
  DEFAULT_MAX_BUDGET_LTR,
  DEFAULT_MAX_BUDGET_STR,
  DEFAULT_STEP_VALUE_BUY,
  DEFAULT_STEP_VALUE_LTR,
  DEFAULT_STEP_VALUE_STR,
  LONG_RENT,
  USER_INFO_KEY,
  USER_TYPE_MEMBER,
} from "../../constants/common";
import { usePrevious } from "../../hooks/usePrevious";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import SelectProperty from "./GitchaGenie/SelectProperty";
import { getInventoryListByUserId } from "../../services/inventoryService";
import AgentPropertyDetails from "./GitchaGenie/AgentPropertyDetails";
import SelectClient from "./GitchaGenie/SelectClient";
import MemberPropertiesData from "./GitchaGenie/MemberPropertiesData";
import Filter from "./GitchaGenie/Filter";
import { useSelector } from "react-redux";

const GitchaHeaderRightTabContent = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { updateFilterGitchaGenie, setShowNoPropertyState, setHeight, divRef } =
    props;

  const options = [
    { value: "newest", label: "Newest" },
    { value: "oldest", label: "Oldest" },
    { value: "highPrice", label: "Highest price" },
    { value: "lowPrice", label: "Lowest price" },
  ];

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [geneshow, setGeneShow] = useState(false);
  const geneHandleClose = () => setGeneShow(false);
  const geneHandleShow = () => setGeneShow(true);

  const [geneclientshow, setGeneClientShow] = useState(false);
  const geneClientHandleClose = () => setGeneClientShow(false);
  const geneClientHandleShow = () => setGeneClientShow(true);

  const [searchParams] = useSearchParams();
  const invIdfromUrl = searchParams.get("InvId");
  const clientIdFromUrl = searchParams.get("ClientId");
  const decodedInvId = invIdfromUrl ? decodeParam(invIdfromUrl) : null;
  const decodedClientId = clientIdFromUrl ? decodeParam(clientIdFromUrl) : null;

  const [adType, setAdType] = useState(getLocalStorage("FilterAdtype") || BUY);
  const previouslySelectedClient = getLocalStorage("MatchSelectedClient");
  const previouslySelectedProperty = getLocalStorage("selectedPropertyId");

  const [budgetRangeGitchaGenie, setBudgetRangeGitchaGenie] = useState("");
  const [selectedProperty, setSelectedProperty] = useState(null);
  const previousBudgetMin = getLocalStorage("priceRangeMatch");
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const userType = _.get(sessionData, "userInfo.userType", "");
  const userId = _.get(sessionData, "userInfo.userId", "");

  const [propertyList, setPropertyList] = useState(null);
  const [clientList, setClientList] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showSelectProperty, setShowSelectProperty] = useState(false);
  const [showSelectClients, setShowSelectClients] = useState(false);
  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails
  );
  const [userDetails, setUserDetails] = useState(null);
  const [sortParam, setSortParam] = useState(options[0]);
  const [currPage, setCurrPage] = useState(1); // storing current page number

  const [searchText, setSearchText] = useState(null);

  let DEFAULT_MAX_BUDGET;
  const DEFAULT_MIN_BUDGET = 0;
  let DEFAULT_STEP_VALUE;

  if (adType === BUY) {
    DEFAULT_MAX_BUDGET = DEFAULT_MAX_BUDGET_BUY;
    DEFAULT_STEP_VALUE = DEFAULT_STEP_VALUE_BUY;
  } else if (adType === LONG_RENT) {
    DEFAULT_MAX_BUDGET = DEFAULT_MAX_BUDGET_LTR;
    DEFAULT_STEP_VALUE = DEFAULT_STEP_VALUE_LTR;
  } else {
    DEFAULT_MAX_BUDGET = DEFAULT_MAX_BUDGET_STR;
    DEFAULT_STEP_VALUE = DEFAULT_STEP_VALUE_STR;
  }

  const budgetMin = previousBudgetMin && previousBudgetMin[0];
  const budgetMax = previousBudgetMin && previousBudgetMin[1];

  const prevMinBdgt = usePrevious(
    budgetRangeGitchaGenie && budgetRangeGitchaGenie[0]
  );
  const prevMaxBdgt = usePrevious(
    budgetRangeGitchaGenie && budgetRangeGitchaGenie[1]
  );
  const prevAdType = usePrevious(adType);
  const prevInventoryId = usePrevious(selectedProperty?.Inv_Id);
  const [isPremiumUser, setIsPremiumUser] = useState(null);

  useEffect(() => {
    getClientList();
    if (userId) {
      dispatch(
        fetchUserDetails({
          userId: userId,
        })
      );
    }
  }, [adType, props.key, isPremiumUser]);

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      setUserDetails(userDetailsFromStore[0]);
      if (userDetailsFromStore[0]?.period !== 1 && userType === 2) {
        setIsPremiumUser(true);
      } else {
        setIsPremiumUser(false);
      }
    } else {
      setUserDetails(null);
    }
  }, [userDetailsFromStore]);
/**
 * To get clients list
 */
  const getClientList = async (searchText = null) => {
    if (userId) {
      await getMatchClientList(userId, searchText)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            responseResult?.ClientList.forEach((obj) =>
              renameKey(obj, "ClientId", "value")
            );
            responseResult?.ClientList.forEach((obj) =>
              combineKey(obj, "FirstName", "LastName", "label")
            );
            setClientList(responseResult?.ClientList);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  useEffect(() => {
    if (clientList && clientList?.length > 0) {
      if (decodedClientId) {
        const clientFromUrl = clientList?.find(
          (client) => client.value == decodedClientId
        );
        if (clientFromUrl) {
          setSelectedClient(clientFromUrl);
        } else {
          setSelectedClient(clientList[0]);
        }
      } else if (previouslySelectedClient) {
        const previousClient = clientList?.find(
          (client) => client.value == previouslySelectedClient.value
        );
        if (previousClient) {
          setSelectedClient(previousClient);
        } else {
          setSelectedClient(clientList[0]);
        }
      } else {
        setSelectedClient(clientList[0]);
      }
    }
  }, [clientList, decodedClientId]);

  useEffect(() => {
    if (prevInventoryId != selectedProperty?.Inv_Id || adType != prevAdType) {
      setLocalStorage("selectedPropertyId", selectedProperty);
      if (divRef.current) {
        setHeight(divRef.current.clientHeight);
      }
      updateFilterGitchaGenie({
        inventoryId: selectedProperty?.Inv_Id,
        city: selectedProperty?.City,
        state: selectedProperty?.State,
      });
    }
  }, [selectedProperty]);

  useEffect(() => {
    if (selectedClient) {
      setLocalStorage("MatchSelectedClient", selectedClient);
      getInventoryList();
    }
    if (adType == adType) {
      let DEFAULT_BUDGET_RANGE = [DEFAULT_MIN_BUDGET, DEFAULT_MAX_BUDGET];

      if (budgetMin && !budgetMax) {
        DEFAULT_BUDGET_RANGE = [budgetMin, DEFAULT_MAX_BUDGET];
      } else if (!budgetMin && budgetMax) {
        DEFAULT_BUDGET_RANGE = [DEFAULT_MIN_BUDGET, budgetMax];
      } else if (budgetMin && budgetMax) {
        DEFAULT_BUDGET_RANGE = [budgetMin, budgetMax];
      }
      setBudgetRangeGitchaGenie(DEFAULT_BUDGET_RANGE);
    } else {
      setBudgetRangeGitchaGenie([DEFAULT_MIN_BUDGET, DEFAULT_MAX_BUDGET]);
    }
  }, [adType, selectedClient]);
/**
 * To get inventory list of selected client
 */
  const getInventoryList = async () => {
    if (userId) {
      let query;
      if (userType == 2 && isPremiumUser) {
        query = {
          adType: adType,
          clientId: selectedClient?.value,
        };
      } else {
        query = {
          adType: adType,
        };
      }
      await getInventoryListByUserId(query)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            if (responseResult.length > 0) {
              setPropertyList(responseResult);
            } else {
              setShowNoPropertyState(true);
              setPropertyList(null);
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };

  useEffect(() => {
    if (propertyList && propertyList.length > 0) {
      if (decodedInvId) {
        const invFromUrl = propertyList.find(
          (property) => property.Inv_Id == decodedInvId
        );
        if (invFromUrl) {
          setSelectedProperty(invFromUrl);
        } else {
          setSelectedProperty(propertyList[0]);
        }
      } else if (previouslySelectedProperty) {
        const previousProperty = propertyList.find(
          (property) => property.Inv_Id == previouslySelectedProperty.Inv_Id
        );
        if (previousProperty) {
          setSelectedProperty(previousProperty);
        } else {
          setSelectedProperty(propertyList[0]);
        }
      } else {
        setSelectedProperty(propertyList[0]);
      }
    } else {
      setSelectedProperty(null);
    }
  }, [propertyList, decodedInvId]);
/**
 * To handle apply filter
 * @param {*} type 
 * @param {*} budget 
 */
  const handleApply = (type, budget) => {
    if (adType != type) {
      setAdType(type);
      removeLocalStorage("filterQuery");
      removeLocalStorage("selectedPropertyId");
      removeLocalStorage("priceRangeMatch");
      setSelectedProperty(null);
      setLocalStorage("FilterAdtype", type);
    } else {
      setBudgetRangeGitchaGenie(budget);
      updateFilterGitchaGenie({
        adType: type,
        priceMin: budget[0],
        priceMax: budget[1],
      });
    }
    handleClose();
  };
/**
 * To handle clear filter
 */
  const clearFilter = () => {
    removeLocalStorage("priceRangeMatch");
    setAdType(BUY);
    setBudgetRangeGitchaGenie([DEFAULT_MIN_BUDGET, DEFAULT_MAX_BUDGET]);
    handleClose();
  };

  useEffect(() => {
    if (propertyList != null) {
      if (prevMinBdgt && prevMinBdgt !== budgetRangeGitchaGenie[0]) {
        setLocalStorage("priceRangeMatch", budgetRangeGitchaGenie);
      }
    }
  }, [budgetRangeGitchaGenie && budgetRangeGitchaGenie[0]]);

  useEffect(() => {
    if (propertyList != null) {
      const mxBdgt =
        budgetRangeGitchaGenie[1] === DEFAULT_MAX_BUDGET
          ? ""
          : budgetRangeGitchaGenie[1];
      if (prevMaxBdgt && prevMaxBdgt !== budgetRangeGitchaGenie[1]) {
        setLocalStorage("priceRangeMatch", budgetRangeGitchaGenie);
      }
    }
  }, [budgetRangeGitchaGenie && budgetRangeGitchaGenie[1]]);

  const reloadClientList = (searchText) => {
    if (searchText) {
      setSearchText(searchText);
    }
    getClientList(searchText);
  };

  return (
    <>
      {showSelectProperty && (
        <SelectProperty
          setShowSelectProperty={setShowSelectProperty}
          propertyList={propertyList}
          selectedProperty={selectedProperty}
          setSelectedProperty={setSelectedProperty}
          userType={userType}
          selectedClient={selectedClient}
          userDetails={userDetails}
          showSelectProperty={showSelectProperty}
        />
      )}
      {showSelectClients && (
        <SelectClient
          clientList={clientList}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          setShowSelectClients={setShowSelectClients}
          showSelectClients={showSelectClients}
          reloadClientList={reloadClientList}
        />
      )}
      {!showSelectClients && !showSelectProperty && (
        <>
          <div className="top-three-comp-shadow">
            <div className="d-flex align-items-center me-3 ms-3">
              <div className="search_wrap_mobile_top">
                <div className="myproperties-heading">My Properties</div>
              </div>
              <div>
                <Button
                  variant=""
                  id="button-addon2"
                  className="btn search-filter-btn"
                  onClick={handleShow}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.125 6.87502H5.70312C5.84081 7.41278 6.15356 7.88942 6.59207 8.22979C7.03057 8.57017 7.56989 8.75492 8.125 8.75492C8.68011 8.75492 9.21943 8.57017 9.65793 8.22979C10.0964 7.88942 10.4092 7.41278 10.5469 6.87502H16.875C17.0408 6.87502 17.1997 6.80917 17.3169 6.69196C17.4342 6.57475 17.5 6.41578 17.5 6.25002C17.5 6.08426 17.4342 5.92529 17.3169 5.80808C17.1997 5.69087 17.0408 5.62502 16.875 5.62502H10.5469C10.4092 5.08726 10.0964 4.61062 9.65793 4.27024C9.21943 3.92987 8.68011 3.74512 8.125 3.74512C7.56989 3.74512 7.03057 3.92987 6.59207 4.27024C6.15356 4.61062 5.84081 5.08726 5.70312 5.62502H3.125C2.95924 5.62502 2.80027 5.69087 2.68306 5.80808C2.56585 5.92529 2.5 6.08426 2.5 6.25002C2.5 6.41578 2.56585 6.57475 2.68306 6.69196C2.80027 6.80917 2.95924 6.87502 3.125 6.87502ZM8.125 5.00002C8.37223 5.00002 8.6139 5.07333 8.81946 5.21068C9.02502 5.34803 9.18524 5.54326 9.27985 5.77167C9.37446 6.00007 9.39921 6.25141 9.35098 6.49388C9.30275 6.73636 9.1837 6.95909 9.00888 7.1339C8.83407 7.30872 8.61134 7.42777 8.36886 7.476C8.12639 7.52423 7.87505 7.49948 7.64665 7.40487C7.41824 7.31026 7.22301 7.15004 7.08566 6.94448C6.94831 6.73892 6.875 6.49725 6.875 6.25002C6.875 5.9185 7.0067 5.60056 7.24112 5.36614C7.47554 5.13172 7.79348 5.00002 8.125 5.00002ZM16.875 13.125H15.5469C15.4092 12.5873 15.0964 12.1106 14.6579 11.7702C14.2194 11.4299 13.6801 11.2451 13.125 11.2451C12.5699 11.2451 12.0306 11.4299 11.5921 11.7702C11.1536 12.1106 10.8408 12.5873 10.7031 13.125H3.125C2.95924 13.125 2.80027 13.1909 2.68306 13.3081C2.56585 13.4253 2.5 13.5843 2.5 13.75C2.5 13.9158 2.56585 14.0748 2.68306 14.192C2.80027 14.3092 2.95924 14.375 3.125 14.375H10.7031C10.8408 14.9128 11.1536 15.3894 11.5921 15.7298C12.0306 16.0702 12.5699 16.2549 13.125 16.2549C13.6801 16.2549 14.2194 16.0702 14.6579 15.7298C15.0964 15.3894 15.4092 14.9128 15.5469 14.375H16.875C17.0408 14.375 17.1997 14.3092 17.3169 14.192C17.4342 14.0748 17.5 13.9158 17.5 13.75C17.5 13.5843 17.4342 13.4253 17.3169 13.3081C17.1997 13.1909 17.0408 13.125 16.875 13.125ZM13.125 15C12.8778 15 12.6361 14.9267 12.4305 14.7894C12.225 14.652 12.0648 14.4568 11.9701 14.2284C11.8755 14 11.8508 13.7486 11.899 13.5062C11.9472 13.2637 12.0663 13.041 12.2411 12.8661C12.4159 12.6913 12.6387 12.5723 12.8811 12.524C13.1236 12.4758 13.3749 12.5006 13.6034 12.5952C13.8318 12.6898 14.027 12.85 14.1643 13.0556C14.3017 13.2611 14.375 13.5028 14.375 13.75C14.375 14.0815 14.2433 14.3995 14.0089 14.6339C13.7745 14.8683 13.4565 15 13.125 15Z"
                      fill="black"
                    />
                  </svg>
                </Button>
              </div>
            </div>
            {userType === USER_TYPE_MEMBER || !isPremiumUser ? (
              <MemberPropertiesData
                propertyList={propertyList}
                setShowSelectProperty={setShowSelectProperty}
                selectedProperty={selectedProperty}
                userDetails={userDetails}
              />
            ) : (
              <AgentPropertyDetails
                propertyList={propertyList}
                setShowSelectProperty={setShowSelectProperty}
                setShowSelectClients={setShowSelectClients}
                clientList={clientList}
                userId={userId}
                selectedClient={selectedClient}
                setSelectedClient={setSelectedClient}
                selectedProperty={selectedProperty}
                userDetails={userDetails}
              />
            )}
          </div>
        </>
      )}
      <Filter
        show={show}
        onHide={handleClose}
        handleApply={(type, budget) => {
          handleApply(type, budget);
        }}
        clearFilter={() => {
          clearFilter();
        }}
        adTypeValue={adType}
        budgetRangeGitchaGenie={budgetRangeGitchaGenie}
        setBudgetRangeGitchaGenie={(value) => {
          setBudgetRangeGitchaGenie(value);
        }}
        handleBudgetMinChange={(e) => {
          handleBudgetMinChange(e);
        }}
        handlebudgetmaxchange={(e) => {
          handleBudgetMaxChange(e);
        }}
      />
    </>
  );
};

export default GitchaHeaderRightTabContent;
